import React, { useState } from 'react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { publicApi } from '../api/client';
import { toast } from '../hooks/use-toast';
import { Send, Loader2 } from 'lucide-react';

const BookingForm = ({ cruiseId, packageId, referenceName, defaultSubject = 'Booking Inquiry', dark = false }) => {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', travel_date: '', travelers: 2, message: '',
  });
  const [busy, setBusy] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await publicApi.createLead({
        ...form,
        subject: defaultSubject,
        cruise_id: cruiseId,
        package_id: packageId,
        reference_name: referenceName,
        travelers: parseInt(form.travelers) || 2,
      });
      toast({ title: 'Inquiry sent', description: "Thank you! Our team will contact you within 24 hours." });
      setForm({ name: '', email: '', phone: '', travel_date: '', travelers: 2, message: '' });
    } catch (err) {
      toast({ title: 'Something went wrong', description: 'Please try again or call us directly.', variant: 'destructive' });
    } finally {
      setBusy(false);
    }
  };

  const inputCls = dark
    ? 'bg-white/10 border-white/20 text-white placeholder:text-white/50'
    : 'bg-white border-slate-200';
  const labelCls = dark ? 'text-white/80' : 'text-slate-700';

  return (
    <form onSubmit={submit} className="space-y-4">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label className={labelCls}>Full Name *</Label>
          <Input required value={form.name} onChange={upd('name')} className={`mt-1.5 h-11 ${inputCls}`} />
        </div>
        <div>
          <Label className={labelCls}>Email *</Label>
          <Input required type="email" value={form.email} onChange={upd('email')} className={`mt-1.5 h-11 ${inputCls}`} />
        </div>
        <div>
          <Label className={labelCls}>Phone / WhatsApp</Label>
          <Input value={form.phone} onChange={upd('phone')} className={`mt-1.5 h-11 ${inputCls}`} />
        </div>
        <div>
          <Label className={labelCls}>Travel Date</Label>
          <Input type="date" value={form.travel_date} onChange={upd('travel_date')} className={`mt-1.5 h-11 ${inputCls}`} />
        </div>
        <div>
          <Label className={labelCls}>Travelers</Label>
          <Input type="number" min={1} value={form.travelers} onChange={upd('travelers')} className={`mt-1.5 h-11 ${inputCls}`} />
        </div>
      </div>
      <div>
        <Label className={labelCls}>Message</Label>
        <Textarea rows={4} value={form.message} onChange={upd('message')} className={`mt-1.5 ${inputCls}`} placeholder="Tell us about your dream Egypt journey..." />
      </div>
      <Button type="submit" disabled={busy} className="w-full h-12 bg-[#304b71] hover:bg-[#6a8aa4] text-white rounded-full">
        {busy ? <><Loader2 size={16} className="mr-2 animate-spin" /> Sending...</> : <>Send Inquiry <Send size={14} className="ml-2" /></>}
      </Button>
    </form>
  );
};

export default BookingForm;
